/* import __COLOCATED_TEMPLATE__ from './prism-progress-bar.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { htmlSafe } from '@ember/template';

/**
 * Renders a visual indication of progress
 *
 * hbs
 * ```
 * <PrismProgressBar @value={{2}} @max={{4}} /> // progress bar will be 50% filled
 * ```
 *
 * hbs
 * ```
 * <PrismProgressBar /> // progress bar will be indeterminate
 * ```
 *
 * @class PrismProgressBar
 */
export default Component.extend({
  classNames: ['prism-progress-bar'],
  classNameBindings: ['indeterminate:prism-progress-bar--indeterminate'],
  attributeBindings: ['style'],
  percent: computed('value', 'max', function () {
    const percent = this.value / this.max * 100;
    switch (true) {
      case percent < 0:
        return 0;
      case percent > 100:
        return 100;
      default:
        return percent;
    }
  }),
  style: computed('percent', function () {
    return htmlSafe(`--percent: ${this.percent}`);
  }),
  /**
   * @argument value
   * @type {Number}
   */
  value: null,
  /**
   * @argument max
   * @type {Number}
   */
  max: null,
  /**
   * @argument indeterminate
   * @type {Boolean}
   */
  indeterminate: computed('percent', function () {
    return Number.isNaN(this.percent);
  })
});